<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { BOOK_TYPE_IMAGE_FOLDER, BOOK_TYPE_PDF, BOOK_TYPE_ZIP } from '@/constants'
import { useFlashMessages } from '@/composables/flashMessages'
import { useLibraryLoader } from '@/composables/libraryLoader'
import PageReader from '@/components/PageReader'
import PdfReader from '@/components/PDFReader'
import ArchiveReader from '@/components/ArchiveReader'
import LoaderDisplay from '@/components/LoaderDisplay'

const store = useStore()
const { getBookHandle } = useLibraryLoader()
const { addErrorMessage } = useFlashMessages()

const readerType = ref('')
const loading = ref(false)

const loadBook = async () => {
  loading.value = true
  const bookHandle = await getBookHandle(store.getters.comicSeries, store.getters.book)
  if (!bookHandle) {
    readerType.value = ''
    addErrorMessage('No book found')
    return
  }
  switch (bookHandle.__bookType) {
    case BOOK_TYPE_IMAGE_FOLDER:
      readerType.value = 'pageReader'
      break
    case BOOK_TYPE_PDF:
      readerType.value = 'pdfReader'
      break
    case BOOK_TYPE_ZIP:
      readerType.value = 'archiveReader'
      break
  }
  if (readerType.value === '') {
    addErrorMessage('Unable to read book')
  }
}

const onReaderLoaded = () => {
  loading.value = false
}

onMounted(async () => {
  loadBook()
})

</script>

<template>
  <div>
    <loader-display v-if="loading"></loader-display>
    <div v-if="readerType === 'pageReader'">
      <page-reader @reader-loaded="onReaderLoaded"></page-reader>
    </div>
    <div v-if="readerType === 'pdfReader'">
      <pdf-reader @reader-loaded="onReaderLoaded"></pdf-reader>
    </div>
    <div v-if="readerType === 'archiveReader'">
      <archive-reader @reader-loaded="onReaderLoaded"></archive-reader>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
